import axiosClient from './axiosClient';

export const apiUpdateQuote = (id?: string, param?: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quote/${id}`;
    return axiosClient.put(url, param);
};
